module.exports = __webpack_public_path__ + "img/hublot-fusion2.fb4e48f4.png";